module.exports = __webpack_public_path__ + "static/img/logo-verde.36b18a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-verde.png
// module id = /LzP
// module chunks = 1